export default "assets/images/icons/demarches-d988c598.svg";